import React, { useCallback, useLayoutEffect, useState } from "react";
import store from "@/store/configureStore"

/**
 * Custom hook listening to React Redux store.
 * @param {(storeState: unknown) => unknown} [slicer] Function slicing through the store to get a specific value.
 * @returns {{slice: any, dispatch: import("redux").Dispatch}}
 */
const useReduxStore = (slicer) => {

    const [slice, setSlice] = useState(null);

    const _slicer = useCallback((_store) => { 
        return slicer ? slicer(_store): _store;
    }, []);
    
    useLayoutEffect(() => {
        function updateSlice() {
            const _slice = _slicer(store.getState());    
            setSlice(_slice);
        }
        const unsubscribe = store.subscribe(updateSlice);
        updateSlice();
        return unsubscribe;
    }, [_slicer]);
    
    return { slice, dispatch: store.dispatch, };
}

export default useReduxStore;


// WEBPACK FOOTER //
// ./src/hooks/useReduxStore.js